import React from 'react';
import styled from 'styled-components';
import { Steps, Typography } from 'antd';
import {
  FileTextOutlined,
  DragOutlined,
  ClockCircleOutlined,
  SaveOutlined,
  DownloadOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const GuideWrapper = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.xl || '12px'};
  padding: ${({ theme }) => theme.spacing.lg || '1.5rem'};

  .ant-steps-item-title {
    font-size: 13px;
  }
  .ant-steps-item-description {
    font-size: 11px;
  }
`;

const GuideTitle = styled(Text)`
  font-family: ${({ theme }) => theme.typography.fontFamily.heading};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent} !important;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.md || '1rem'};
`;

const steps = [
  {
    title: 'Generate MSR Report',
    description: 'Create a Monthly Service Report from the Reports page first.',
    icon: <FileTextOutlined />,
  },
  {
    title: 'Drag Templates',
    description: 'Drag recommendation templates from the palette onto page zones.',
    icon: <DragOutlined />,
  },
  {
    title: 'Set Timeframes',
    description: 'Choose an implementation timeframe for each recommendation.',
    icon: <ClockCircleOutlined />,
  },
  {
    title: 'Save Placements',
    description: 'Save your recommendation layout to the report.',
    icon: <SaveOutlined />,
  },
  {
    title: 'Generate PDF',
    description: 'Merge recommendation pages with the MSR report and download.',
    icon: <DownloadOutlined />,
  },
];

const RecommendationGuide = () => {
  return (
    <GuideWrapper>
      <GuideTitle>How It Works</GuideTitle>
      <Steps
        direction="vertical"
        size="small"
        current={-1}
        items={steps}
      />
    </GuideWrapper>
  );
};

export default React.memo(RecommendationGuide);
